export default __webpack_public_path__ + "d980893f270f8b6d6568a55151f0e4a1.png";